import { useEffect, useState } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

import BlogPostCard from "./BlogPostCard";

// Material Kit 2 PRO React examples
import Navbar from "components/Navbar";
import ProjectHeader from "./BlogPostsHeader";
import Footer from "components/Footer";

import Post20251206Image from "./PostContents/20251206-LaChuaTrail/IMG_8240 Copy.jpg"; 

const tagColors = {
  "Hiking": "#4caf50",
  "Programming": "#2196f3",
  "News": "#ff9800",
  "Gaming": "#9c27b0",
}

const posts = [
  { 
    title: "La Chua Trail Hike",
    subtitle: "December 6th, 2025", color: "info",
    tags: ["Hiking"],
    description: "",
    image: Post20251206Image,
    url: "/posts/20251206-LaChuaTrail",
  },
];

function PostsPage() {
  
  return (
    <>
      <Navbar />
      <ProjectHeader />
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid container spacing={3}>
            {posts.map((post, index) => (
              <Grid item key={post.title} xs={12} md={6} sx={{ mb: 4 }}>
                <BlogPostCard title={post.title} subtitle={post.subtitle} 
                  color={post.color} description={post.description} image={post.image} 
                  tags={post.tags} url={post.url}
                />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <Footer />
      </MKBox>
    </>
  );
}

export default PostsPage;
